import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'eos-signin-oidc',
  templateUrl: './signin-oidc.component.html',
  styleUrls: ['./signin-oidc.component.css']
})
export class SigninOidcComponent implements OnInit {
  returnUrl: any;

	constructor( private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService) {

   }

	ngOnInit() {
  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || localStorage.getItem('returnUrl') || '/';
    if (this.authService.isAuthenticated) {
      this.router.navigate([this.returnUrl]);
      return;
    }

    localStorage.setItem('returnUrl', this.returnUrl);
    this.authService.login();
	 }
}
